import axios from "axios"
import { RuleType } from "../../types"

export interface ICreateRuleParams {
    type: RuleType,
    name: string,
    startDateTime: string,
    endDateTime?: string,
    skip: number,
    applyFor?: number,
    mailingList: string[] | null,
    alertOnSetting: boolean | null,
    alertOnActivation: boolean | null,
    pickupDateTimeFrom?: {
        value: string,
        excluded: boolean
    },
    pickupDateTimeTo?: {
        value: string,
        excluded: boolean
    },
    dropoffDateTimeFrom?: {
        value: string,
        excluded: boolean
    },
    dropoffDateTimeTo?: {
        value: string,
        excluded: boolean
    },
    includingDateTimeFrom?: {
        value: string,
        excluded: boolean
    },
    includingDateTimeTo?: {
        value: string,
        excluded: boolean
    },
    pickupLocations?: {
        value: string[],
        excluded: boolean
    },
    dropoffLocations?: {
        value: string[],
        excluded: boolean
    },
    pickupAreas?: {
        value: string[],
        excluded: boolean
    },
    dropoffAreas?: {
        value: string[],
        excluded: boolean
    },
    pickupRegions?: {
        value: string[],
        excluded: boolean
    },
    dropoffRegions?: {
        value: string[],
        excluded: boolean
    },
    pickupZones?: {
        value: string[],
        excluded: boolean
    },
    dropoffZones?: {
        value: string[],
        excluded: boolean
    },
    acrissList?: {
        value: string[],
        excluded: boolean
    },
    sippList?: {
        value: string[],
        excluded: boolean
    },
    customerCodes?: {
        value: string[],
        excluded: boolean
    },
    salesChannels?: {
        value: string[],
        excluded: boolean
    },
    segments?: {
        value: string[],
        excluded: boolean
    },
    categories?: {
        value: string[],
        excluded: boolean
    },
    products?: {
        value: string[],
        excluded: boolean
    },
    rates?: {
        value: string[],
        excluded: boolean
    },
    ancillaries?: {
        value: string[],
        excluded: boolean
    },
    minDuration?: {
        value: number,
        excluded: boolean
    },
    maxDuration?: {
        value: number,
        excluded: boolean
    },
    minNoticeDays?: {
        value: number,
        excluded: boolean
    },
    maxNoticeHours?: {
        value: number,
        excluded: boolean
    },
    tenants: {
        value: string[]
    },
    dealers: {
        value: string[]
    }
};

export const createRule = async (params: ICreateRuleParams): Promise<void> => {
    const response = await axios.post('/booking/rule', params);
    return response.data;
};